<template>
  <div class="column">
    <div class="columns">
      <div class="column">
        <div v-if="tasks === null" style="height: 48px"
             class="is-flex is-align-items-center dashed-border-small ml-0 mr-0 mt-auto mb-auto">
          <h5 class="is-size-6 m-auto has-text-grey-light has-text-weight-light has-text-centered" style="line-height: 1">{{getMessage()}}</h5>
        </div>
        <div v-else-if="tasks != null" style="height: 48px" class="is-flex mt-auto mb-auto">
          <div class="clickable-info has-text-centered is-flex ml-1" style="height: 48px; width: 80px"
               :style="statusStyle()" @click="showError">
            <div class="is-size-7 mt-auto mb-auto ml-auto mr-auto has-text-white">{{ tasks.status }}</div>
          </div>
          <div class="clickable-info ml-2 is-flex pt-2 pl-4" style="flex-grow: 1">
            <div class="m-0" style="flex: 1">
              <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px;">
                {{ tasks.status === 'CREATED' ? 'CREATED TASKS' : 'QUEUED' }}
              </div>
              <div class="has-text-black has-text-weight-bold" style="line-height: 1">
                {{ tasks.status === 'CREATED' ? tasks.created : tasks.queued }}
              </div>
            </div>
            <div class="m-0" style="flex: 1" v-if="tasks.status !== 'CREATED'">
              <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">IN PROGRESS</div>
              <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                  tasks.inProgress
                }}
              </div>
            </div>
            <div style="flex: 0.5" class="is-flex" v-if="tasks.status !== 'CREATED'">
              <hr class="mt-0 mb-1 ml-auto mr-auto has-background-grey-lighter" style="width: 1px; height: 30px">
            </div>
            <div class="m-0" style="flex: 1" v-if="tasks.status !== 'CREATED'">
              <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">FAILED</div>
              <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                  tasks.failed
                }}
              </div>
            </div>
            <div class="m-0" style="flex: 1" v-if="tasks.status !== 'CREATED'">
              <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">COMPLETED</div>
              <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                  tasks.completed
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewGuard from "@/components/view-guard/view-guard.vue";
import {isAllowed} from "@/utils/utils";

export default {
  name: "simple-tasks-info",
  props: {
    tasks: {
      type: Object
    },
    propertySet:{
      type: Boolean
    },
    refreshing: {
      type: Boolean
    }
  },
  data() {
    return {
      progressValue: 40,
    }
  },
  mounted() {
    console.log('Mounted tasks: ', this.tasks)
  },
  methods: {
    setProgress(progress) {
      this.progressValue = progress
    },
    showError() {
      console.log('On show error')
      if (this.tasks && this.tasks.errors && this.tasks.errors.length > 0) {
        this.$emit('onShowError', this.tasks.errors)
      } else if (this.tasks && this.tasks.notes && this.tasks.notes.length > 0) {
        let errors = []
        this.tasks.notes.forEach(note => {
          errors.push({error: note})
        })
        this.$emit('onShowError', errors)
      }
    },
    getMessage() {
      if(this.propertySet){
        return 'Please wait for processing info...'
      }  else {
        return 'Unknown status'
      }
    },
    statusStyle() {
      if (this.tasks && this.tasks.status) {
        if (this.tasks.status === 'CREATED') {
          return {background: '#8C84FF'}
        } else if (this.tasks && this.tasks.status === 'RUNNING') {
          return {background: '#D8BA13'}
        } else if (this.tasks && this.tasks.status === 'COMPLETED') {
          return {background: '#1CAB80'}
        } else if (this.tasks && this.tasks.status === 'FAILED') {
          if (this.tasks && (this.tasks.errors && this.tasks.errors.length > 0)
              || (this.tasks.notes && this.tasks.notes.length > 0)) {
            return {background: '#e02c2c', cursor: 'pointer'}
          } else {
            return {background: '#e02c2c'}
          }
        }
      }
      return {background: '#000000'}
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    }
  }
}
</script>

<style scoped lang="scss">
.dashed-border-small {
  padding: 8px 8px;
  border-style: dashed;
  border-radius: 8px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.1);
}

.clickable-info {
  background: #efefef;
  border-radius: 0.3rem;
}

/*.clickable-info:hover {
  cursor: pointer;
}*/

.clickable:hover {
  cursor: pointer;
}

.dashed-border-small {
  padding: 8px 8px;
  border-style: dashed;
  border-radius: 8px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.1);
}

.my-loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #1cab80;
  border-bottom: 4px solid #1cab80;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>